import { createSlice } from "@reduxjs/toolkit";

export const estoreSlice = createSlice({
  name: "estoreSet",
  initialState: {},
  reducers: {
    estoreDet: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { estoreDet } = estoreSlice.actions;

export default estoreSlice.reducer;
